import Holidays from 'date-holidays';

const hdInstance = new Holidays('BR', 'SP', 'SP');
hdInstance.setHoliday('2021-03-26', { name: 'antecipated-holiday', type: 'public' });
export default hdInstance;
